import prologue from "./partials/prologue.mjs";
// eslint-disable-next-line no-unused-vars
export default function Builder() {
  return { ...prologue(),

    build({
      base
    } = {}) {
      const queryResult = this._getTemplateResult().toString({
        base
      });

      if (this.prologueResult) {
        return `${this.prologueResult}\n\n${queryResult}`;
      }

      return queryResult;
    },

    _toPartialString(options) {
      return this._getTemplateResult()._toPartialString(options);
    }

  };
}